//export const ApiUrl = "http://127.0.0.1:8000/api/";
export const ApiUrl = "https://api.istmas.edu.ec/api/";
